import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/Home'
        }, {
          path: '/Home',
          name: 'Home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '官网首页'
          }
        }, {
          path: '/Production',
          name: 'Production',
          component: resolve => require(['@/view/Production'], resolve),
          meta: {
            title: '产品中心'
          }
        }, {
          path: '/About',
          name: 'About',
          component: resolve => require(['@/view/About'], resolve),
          meta: {
            title: '关于我们'
          }
        }
        , {
          path: '/Products',
          name: 'Products',
          component: resolve => require(['@/view/Products'], resolve),
          meta: {
            title: '旗下平台'
          }
        }, {
          path: '/ProductionInfo',
          name: 'ProductionInfo',
          component: resolve => require(['@/view/ProductionInfo'], resolve),
          meta: {
            title: '产品详情'
          }
        }


      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js